import { environment } from './environment'
import { injectScript } from './injectScript'
import { captureException } from './sentryClient'

export { environment } from './environment'
export { injectScript } from './injectScript'
export { captureException, initSentry } from './sentryClient'
export type {
  ChiliDeanonInterface,
  ChiliTrackingInterface,
  DebugMode,
  Product,
  ProductEvent,
  ProductEventType,
  ProductEvents,
  TrackingEventCallback,
  TrackingEventName,
  TrackingInitParams,
  TrackingMode,
  TrackingTraits,
} from './types'

export const loadDeanonScript = async (): Promise<void> => {
  if (window.ChiliDeanon) return

  const embedUrl = `${environment.baseUrl}/web-data/deanonymization/embed/index.js`

  await injectScript(embedUrl).catch(error => {
    captureException(error)
    console.error('Error loading deanon script', error) // eslint-disable-line no-console
  })
}

export const getDeanonGlobal = (): typeof window.ChiliDeanon | null => {
  return window.ChiliDeanon ?? null
}

export const getTrackingGlobal = (): typeof window.ChiliTracking | null => {
  return window.ChiliTracking ?? null
}
